import React from "react";
import PageContents from "../components/layouts/PageContents";
import UserApiAccessForm from "../components/projectusers/UserApiAccessForm";

const ApiAccessPage: React.FC = () => {
    return (
        <PageContents
            title="API Access"
            subtitle="Manage your API Access."
            isForbidden={false}
            variant="small"
        >
            <UserApiAccessForm />
        </PageContents>
    );
};

export default ApiAccessPage;
